import { MaterialCommunityIcons } from '@expo/vector-icons';
import { Asset, Media } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Menu } from 'react-native-paper';
import { EditFileForm } from '../../files/components/editFileForm';
import { ModalButton } from '../../shared/components/modalButton';
import { DeleteAssetFileModal } from './deleteAssetFileModal';

export const AssetFileItemMenu = ({
  asset,
  media,
  invalidateQuery,
  disabled,
}: {
  asset: Asset;
  media: Media;
  invalidateQuery: () => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();

  const [menuVisible, setMenuVisible] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const openMenu = () => {
    setMenuVisible(true);
  };

  const closeMenu = () => {
    setMenuVisible(false);
  };

  const onUpdateAsset = (id: string, title?: string) => {
    closeMenu();
  };

  return (
    <View>
      <Menu
        statusBarHeight={0}
        visible={menuVisible}
        onDismiss={closeMenu}
        contentStyle={styles.menu}
        anchor={
          <TouchableOpacity onPress={openMenu} disabled={disabled}>
            <MaterialCommunityIcons
              name="dots-horizontal"
              color={Colors.black}
              size={24}
            />
          </TouchableOpacity>
        }
      >
        <ModalButton
          label=""
          customButton={
            <Menu.Item
              trailingIcon={'pencil-outline'}
              titleStyle={styles.edit}
              title={t('asset.detail.edit')}
            />
          }
          modalComponent={({ onComplete }) => {
            return (
              <EditFileForm
                onComplete={() => {
                  onComplete();
                  closeMenu();
                  invalidateQuery();
                }}
                fileId={media.id}
              />
            );
          }}
          containerStyle={styles.modalContainer}
        />
        <Menu.Item
          trailingIcon={'trash-can-outline'}
          titleStyle={styles.delete}
          onPress={() => {
            setIsDeleteModalVisible(true);
            closeMenu();
          }}
          title={t('asset.detail.delete')}
          theme={{ colors: { onSurfaceVariant: Colors.red } }}
        />
      </Menu>
      <DeleteAssetFileModal
        visible={isDeleteModalVisible}
        hide={() => setIsDeleteModalVisible(false)}
        media={media}
        asset={asset}
        onDelete={() => {
          closeMenu();
          invalidateQuery();
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  menu: {
    backgroundColor: Colors.white,
    top: 30,
    left: 0,
  },
  edit: {
    fontSize: 17,
  },
  delete: {
    color: Colors.red,
    fontSize: 17,
  },
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
    width: 560,
  },
});
